import axios from "@/api/axiosInstance";
import { FetchDashboardChartConfigsResponse } from "./types";

export const fetchDashboardChartConfigs =
  async (): Promise<FetchDashboardChartConfigsResponse> => {
    const response = await axios.get<FetchDashboardChartConfigsResponse>(
      "/api/private/administration/stochastic/dashboard-chart-configs",
    );
    return response.data;
  };
